"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.admin_mall = void 0;
var utils_1 = require("../../utils");
// [Mall]
exports.admin_mall = function (axios) {
    return {
        getMalls: function () {
            return axios.get('/malls');
        },
        getMallsMallNo: function (request) {
            var url = utils_1.paramPathchange('/malls/{mallNo}', request);
            return axios.get(url);
        },
        getMallsConfigurations: function (getMallsConfigurationsRequest) {
            var url = utils_1.paramPathchange('/malls/{mallNo}/configurations', getMallsConfigurationsRequest);
            return axios.get(url, getMallsConfigurationsRequest);
        },
        getMallsContractedPartnersByMallNo: function (getMallsContractedPartnersByMallNoRequest) {
            var url = '/malls/{mallNo}/contracted-partners';
            url = utils_1.paramPathchange(url, getMallsContractedPartnersByMallNoRequest);
            return axios.get(url, getMallsContractedPartnersByMallNoRequest);
        },
        getMallsDeliveryPartnersByMallNo: function (getMallsDeliveryPartnersByMallNoRequest) {
            return axios.get("/malls/" + getMallsDeliveryPartnersByMallNoRequest.params.mallNo + "/delivery-partner");
        },
        getMallsMallNoGodoAuth: function (request) {
            return axios.get("/malls/" + request.pathParams.mallNo + "/godo-auth");
        },
        postMalls: function (request) {
            return axios.post('/malls', request.data);
        },
        getMallsData: function (request) {
            return axios.get("/malls/" + request.params.mallNo);
        },
        putMalls: function (request) {
            return axios.put("/malls/" + request.params.mallNo, request.data);
        },
        patchMallsMallNo: function (request) {
            return axios.patch("/malls/" + request.pathParams.mallNo, request.data);
        },
        getMallsMallNoConfigurationI18n: function (request) {
            return axios.get("/malls/" + request.pathParams.mallNo + "/configuration/i18n");
        },
        getMallsMallNoConfigurationSeo: function (request) {
            return axios.get("/malls/" + request.pathParams.mallNo + "/configuration/seo");
        },
        putMallsMallNoConfigurationI18n: function (request) {
            return axios.put("/malls/" + request.pathParams.mallNo + "/configuration/i18n", request.data);
        },
        postMallsMallNoConfigurationI18nCurrency: function (request) {
            return axios.post("/malls/" + request.pathParams.mallNo + "/configuration/i18n/currency", request.data);
        },
        putMallsMallNoConfigurationI18nCurrencyRate: function (request) {
            return axios.put("/malls/" + request.pathParams.mallNo + "/configuration/i18n/currency-rate", request.data);
        },
        putMallsMallNoConfigurationSeo: function (request) {
            return axios.put("/malls/" + request.pathParams.mallNo + "/configuration/seo", request.data);
        },
        deleteMallsMallNoConfigurationSeo: function (request) {
            return axios.delete("/malls/" + request.pathParams.mallNo + "/configuration/seo/" + request.pathParams.seoType);
        }
    };
};
